import { useInfiniteQuery } from "@tanstack/react-query";
import { useShop } from "src/hooks/Utils/Shop/useShop";
import { OpenapiSingleton } from "src/utils/OpenapiSingleton";

export default function useSellerMyProductList(enabled?: boolean) {

  const { shopMarketId, shopLang } = useShop();

  const getMyProductList = async ({ pageParam = 0 }) => {
    return await OpenapiSingleton.SellerProductAPIApi.listMyProducts(
      shopMarketId,
      pageParam,
      24,
      ["desc"],
      shopLang,
    );
  };

  return useInfiniteQuery({
    queryKey: ["getMyProductList"],
    queryFn: getMyProductList,
    enabled: enabled,
    refetchInterval: (data) => {
      const stateData = data?.pages?.some(page =>
        page?.data?.content?.some(item => item?.state === "PAUSED_PENDING_EVALUATION_AI")
      );
      return stateData ? 5000 : false;
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.data.pageable.pageNumber + 1 < lastPage.data.totalPages) {
        return lastPage.data.pageable.pageNumber + 1;
      }
      return undefined;
    },
  });
}
